export enum PaymentStatuses {
  INVALID = "INVALID",
  DRAFT = "DRAFT",
  IN_PROCESS = "IN_PROCESS",
  CANCELLED = "CANCELLED",
  PAID = "PAID",
}
